import {
  numberToChar93r9buh19yek as numberToChar,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  maxOrNull2lr3mpfpypi46 as maxOrNull,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Char19o2r8palgjof as Char,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  fill3lmv1pckd4inv as fill,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toByte4i43936u611k as toByte,
  charArray2ujmm1qusno00 as charArray,
  concatToString2syawgu50khxi as concatToString,
  ArrayList3it5z8td81qkl as ArrayList,
  coerceIn10f36k81le1mm as coerceIn,
  substring2pnd9wgs9hwtx as substring,
  Regexxgw0gjiagf4z as Regex,
  lazy2hsh8ze7j6ikd as lazy,
  copyOf3rutauicler23 as copyOf,
  copyOfRange1v9olvyjr7c0r as copyOfRange,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  contentEquals2jbsaphs7gxql as contentEquals,
  startsWith1bgirhbedtv2y as startsWith,
  endsWith278181ii8uuo as endsWith,
  toString14fd7g605f91p as toString_0,
  toInt5qdj874w69jh as toInt,
  substringAfter1hku067gwr5ve as substringAfter,
  contains2el4s70rdq4ld as contains,
  substringBefore3n7kj60w69hju as substringBefore,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  coerceAtMost322komnqp70ag as coerceAtMost,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  hv(_this__u8e3s4, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) || codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract(U0, 10, 10);
      var ls = extract(U0, 0, 10);
      _this__u8e3s4.pb(numberToChar(55296 | hs));
      _this__u8e3s4.pb(numberToChar(56320 | ls));
    } else {
      _this__u8e3s4.pb(numberToChar(codePoint));
    }
  }
}
class Charset {
  constructor(name) {
    this.iv_1 = name;
  }
  jv(nbytes) {
    return imul(nbytes, 2);
  }
}
class UTC8CharsetBase extends Charset {
  jv(nbytes) {
    return imul(nbytes, 2);
  }
  kv(out, src, start, end) {
    if (start < 0 || start > src.length || (end < 0 || end > src.length)) {
      // Inline function 'kotlin.error' call
      var message = 'Out of bounds';
      throw IllegalStateException.w4(toString(message));
    }
    var i = start;
    loop: while (i < end) {
      var c = src[i] & 255;
      var tmp4_subject = c >> 4;
      if (0 <= tmp4_subject ? tmp4_subject <= 7 : false) {
        Companion_instance.hv(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp4_subject ? tmp4_subject <= 13 : false) {
        if ((i + 1 | 0) >= end)
          break loop;
        Companion_instance.hv(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp4_subject === 14) {
        if ((i + 2 | 0) >= end)
          break loop;
        Companion_instance.hv(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp4_subject === 15) {
        if ((i + 3 | 0) >= end)
          break loop;
        Companion_instance.hv(out, insert(insert(insert(insert(0, extract(src[i + 0 | 0], 0, 3), 18, 3), extract(src[i + 1 | 0], 0, 6), 12, 6), extract(src[i + 2 | 0], 0, 6), 6, 6), extract(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.pb(_Char___init__impl__6a9atx(65533));
        i = i + 1 | 0;
      }
    }
    return i - start | 0;
  }
}
class BaseSingleByteCharset extends Charset {
  jv(nbytes) {
    return nbytes;
  }
}
class SingleByteCharset extends BaseSingleByteCharset {
  constructor(name, conv) {
    super(name);
    this.nv_1 = conv;
    var tmp = this;
    var tmp5_safe_receiver = maxOrNull(this.nv_1);
    var tmp_0;
    var tmp_1 = tmp5_safe_receiver;
    if ((tmp_1 == null ? null : new Char(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = Char__plus_impl_qi7pgj(tmp5_safe_receiver, 1);
    }
    var tmp6_safe_receiver = tmp_0;
    var tmp_2;
    var tmp_3 = tmp6_safe_receiver;
    if ((tmp_3 == null ? null : new Char(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.code' call
      tmp_2 = Char__toInt_impl_vasixd(tmp6_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp_2;
    tmp.ov_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_4 = this;
    // Inline function 'kotlin.also' call
    var this_0 = new Int8Array(this.ov_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.SingleByteCharset.v.<anonymous>' call
    fill(this_0, 63);
    var inductionVariable = 0;
    var last = charSequenceLength(this.nv_1) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_1 = charSequenceGet(this.nv_1, n);
        this_0[Char__toInt_impl_vasixd(this_1)] = toByte(n);
      }
       while (inductionVariable <= last);
    tmp_4.pv_1 = this_0;
  }
  kv(out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.pb(charSequenceGet(this.nv_1, src[n] & 255));
      }
       while (inductionVariable < end);
    return end - start | 0;
  }
}
class ISO_8859_1 extends SingleByteCharset {
  constructor() {
    ISO_8859_1_instance = null;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.ISO_8859_1.<init>.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.pb(numberToChar(n));
      }
       while (inductionVariable < 256);
    super('ISO-8859-1', this_0.toString());
    ISO_8859_1_instance = this;
  }
}
class UTF16Charset extends Charset {
  constructor(le) {
    super('UTF-16-' + (le ? 'LE' : 'BE'));
    this.sv_1 = le;
  }
  jv(nbytes) {
    return imul(nbytes, 2);
  }
  kv(out, src, start, end) {
    var consumed = 0;
    var progression = step(until(start, end), 2);
    var inductionVariable = progression.a2_1;
    var last = progression.b2_1;
    var step_0 = progression.c2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var char = numberToChar(getS16(src, n, this.sv_1));
        out.pb(char);
        consumed = consumed + 2 | 0;
      }
       while (!(n === last));
    return consumed;
  }
}
class ASCII extends SingleByteCharset {
  constructor() {
    ASCII_instance = null;
    var tmp = 0;
    var tmp_0 = charArray(128);
    while (tmp < 128) {
      var tmp_1 = tmp;
      tmp_0[tmp_1] = numberToChar(tmp_1);
      tmp = tmp + 1 | 0;
    }
    super('ASCII', concatToString(tmp_0) + '\xC7\xFC\xE9\xE2\xE4\xE0\xE5\xE7\xEA\xEB\xE8\xEF\xEE\xEC\xC4\xC5\xC9\xE6\xC6\xF4\xF6\xF2\xFB\xF9\xFF\xD6\xDC\xF8\xA3\xD8\xD7\u0192\xE1\xED\xF3\xFA\xF1\xD1\xAA\xBA\xBF\xAE\xAC\xBD\xBC\xA1\xAB\xBB\u2591\u2592\u2593\u2502\u2524\xC1\xC2\xC0\xA9\u2563\u2551\u2557\u255D\xA2\xA5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xE3\xC3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xA4\xF0\xD0\xCA\xCB\xC8\u0131\xCD\xCE\xCF\u2518\u250C\u2588\u2584\xA6\xCC\u2580\xD3\xDF\xD4\xD2\xF5\xD5\xB5\xFE\xDE\xDA\xDB\xD9\xFD\xDD\xAF\xB4\xAD\xB1\u2017\xBE\xB6\xA7\xF7\xB8\xB0\xA8\xB7\xB9\xB3\xB2\u25A0\xA0');
    ASCII_instance = this;
  }
}
class Charsets {
  tv() {
    return get_LATIN1();
  }
}
class WStringReader {
  constructor(str, position) {
    position = position === VOID ? 0 : position;
    this.uv_1 = str;
    this.vv_1 = position;
  }
  wv() {
    return this.uv_1.a() - this.vv_1 | 0;
  }
  bw() {
    return this.vv_1 >= this.uv_1.a();
  }
  cw() {
    return !this.bw();
  }
  dw(offset) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.WString.getOrElse' call
      var this_0 = this.uv_1;
      var index = this.vv_1 + offset | 0;
      if (index < 0 || index >= this_0.a()) {
        // Inline function 'korlibs.io.lang.WStringReader.peek.<anonymous>' call
        tmp$ret$1 = _WChar___init__impl__4vbl4k(0);
        break $l$block;
      }
      tmp$ret$1 = this_0.ew(index);
    }
    return tmp$ret$1;
  }
  fw(offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.dw(offset) : $super.dw.call(this, offset).gw_1;
  }
  hw(count) {
    this.vv_1 = this.vv_1 + count | 0;
  }
  iw(offset, len) {
    return substr_1(this.uv_1, this.vv_1 + offset | 0, len);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$0 = new Int32Array([]);
    tmp.jw_1 = new WString(tmp$ret$0, '');
  }
  kw(codePoints) {
    return this.lw(codePoints);
  }
  mw(string) {
    return this.nw(string);
  }
  nw(string) {
    if (string === '')
      return this.jw_1;
    var codePoints = new Int32Array(string.length);
    // Inline function 'korlibs.io.lang.forEachCodePoint' call
    var string_0 = string;
    var m = 0;
    var n = 0;
    while (n < string_0.length) {
      // Inline function 'kotlin.code' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var this_0 = charSequenceGet(string_0, _unary__edvuaz);
      var value = Char__toInt_impl_vasixd(this_0);
      var error = false;
      if ((value & 63488) === 55296 && n < string_0.length) {
        // Inline function 'kotlin.code' call
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var this_1 = charSequenceGet(string_0, _unary__edvuaz_0);
        var extra = Char__toInt_impl_vasixd(this_1);
        if (!((extra & 64512) === 56320)) {
          n = n - 1 | 0;
          error = true;
        } else {
          var dataHigh = value & 1023;
          var dataLow = extra & 1023;
          value = (dataLow | dataHigh << 10) + 65536 | 0;
        }
      }
      // Inline function 'korlibs.io.lang.Companion.fromString.<anonymous>' call
      var _unary__edvuaz_1 = m;
      m = _unary__edvuaz_1 + 1 | 0;
      codePoints[_unary__edvuaz_1] = value;
    }
    var length = m;
    return new WString(copyOf(codePoints, length), string);
  }
  lw(codePoints) {
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var inductionVariable = 0;
    var last = codePoints.length;
    while (inductionVariable < last) {
      var element = codePoints[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.io.lang.Companion.fromCodePoints.<anonymous>' call
      if (element >= 65536) {
        count = count + 1 | 0;
      }
    }
    var surrogateCount = count;
    var out = StringBuilder.tb(codePoints.length + surrogateCount | 0);
    var inductionVariable_0 = 0;
    var last_0 = codePoints.length;
    while (inductionVariable_0 < last_0) {
      var codePoint = codePoints[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (codePoint > 65535) {
        var U1 = codePoint - 65536 | 0;
        var W1 = 55296 | (U1 >>> 10 | 0) & 1023;
        var W2 = 56320 | (U1 >>> 0 | 0) & 1023;
        out.pb(numberToChar(W1));
        out.pb(numberToChar(W2));
      } else {
        out.pb(numberToChar(codePoint));
      }
    }
    return new WString(codePoints, out.toString());
  }
}
class WString {
  constructor(codePoints, string) {
    Companion_getInstance_0();
    this.xv_1 = codePoints;
    this.yv_1 = string;
    this.zv_1 = 0;
    this.aw_1 = false;
  }
  a() {
    return this.xv_1.length;
  }
  ew(index) {
    return _WChar___init__impl__4vbl4k(this.xv_1[index]);
  }
  xg(startIndex, endIndex) {
    var tmp = copyOfRange(this.xv_1, startIndex, endIndex);
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.yv_1.substring(startIndex, endIndex);
    return new WString(tmp, tmp$ret$1);
  }
  hashCode() {
    if (!this.aw_1) {
      this.aw_1 = true;
      this.zv_1 = contentHashCode(this.xv_1);
    }
    return this.zv_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof WString) {
      tmp = contentEquals(this.xv_1, other.xv_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return this.yv_1;
  }
}
class INDENTS {
  constructor() {
    INDENTS_instance = this;
    this.ow_1 = new Object();
    this.pw_1 = StringBuilder.tb(1024);
    this.qw_1 = ArrayList.w(1024);
  }
  d1(index) {
    if (this.qw_1.e1() <= index) {
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this.ow_1;
      while (INDENTS_getInstance().qw_1.e1() <= index) {
        INDENTS_getInstance().qw_1.h(INDENTS_getInstance().pw_1.toString());
        INDENTS_getInstance().pw_1.pb(_Char___init__impl__6a9atx(9));
      }
    }
    return this.qw_1.d1(index);
  }
}
class SimpleStrReader {}
function toStringContext() {
  return 'SimpleStrReader(pos=' + this.tw() + ", peek='" + toString_0(this.rw()) + "')";
}
class Impl {
  constructor(str, pos) {
    this.uw_1 = str;
    this.vw_1 = pos;
  }
  tw() {
    return this.vw_1;
  }
  cw() {
    return this.vw_1 < this.uw_1.length;
  }
  sw() {
    // Inline function 'kotlin.also' call
    var this_0 = new Char(this.rw());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.util.Impl.readChar.<anonymous>' call
    this_0.k2_1;
    this.vw_1 = this.vw_1 + 1 | 0;
    return this_0.k2_1;
  }
  rw() {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.uw_1;
    var index = this.vw_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      // Inline function 'korlibs.util.Impl.peekChar.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  }
  toString() {
    return "Impl(str='" + this.uw_1 + "', pos=" + this.vw_1 + ')';
  }
  ww() {
    var tmp = this.vw_1;
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.uw_1;
    var startIndex = coerceAtMost(this.vw_1, this.uw_1.length);
    var endIndex = coerceAtMost(this.vw_1 + 10 | 0, this.uw_1.length);
    // Inline function 'kotlin.js.asDynamic' call
    return 'SimpleStrReader(pos=' + tmp + ", around='" + this_0.substring(startIndex, endIndex) + "')";
  }
}
class Companion_1 {
  xw(str, pos) {
    return new Impl(str, pos);
  }
  yw(str, pos, $super) {
    pos = pos === VOID ? 0 : pos;
    return $super === VOID ? this.xw(str, pos) : $super.xw.call(this, str, pos);
  }
}
//endregion
var CHARSET_PROVIDERS;
var CHARSET_PROVIDERS_LOCK;
function get_UTF8() {
  _init_properties_Charset_kt__c47y1m();
  return UTF8;
}
var UTF8;
function get_LATIN1() {
  _init_properties_Charset_kt__c47y1m();
  return LATIN1;
}
var LATIN1;
var UTF16_LE;
function get_UTF16_BE() {
  _init_properties_Charset_kt__c47y1m();
  return UTF16_BE;
}
var UTF16_BE;
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var ISO_8859_1_instance;
function ISO_8859_1_getInstance() {
  if (ISO_8859_1_instance === VOID)
    new ISO_8859_1();
  return ISO_8859_1_instance;
}
function toString_1(_this__u8e3s4, charset, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.length : end;
  _init_properties_Charset_kt__c47y1m();
  var out = StringBuilder.tb(charset.jv(end - start | 0));
  charset.kv(out, _this__u8e3s4, start, end);
  return out.toString();
}
var ASCII_instance;
function ASCII_getInstance() {
  if (ASCII_instance === VOID)
    new ASCII();
  return ASCII_instance;
}
var Charsets_instance;
function Charsets_getInstance() {
  return Charsets_instance;
}
var properties_initialized_Charset_kt_dajgec;
function _init_properties_Charset_kt__c47y1m() {
  if (!properties_initialized_Charset_kt_dajgec) {
    properties_initialized_Charset_kt_dajgec = true;
    // Inline function 'kotlin.collections.arrayListOf' call
    CHARSET_PROVIDERS = ArrayList.h1();
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    CHARSET_PROVIDERS_LOCK = get_atomicfu$reentrantLock();
    UTF8 = new UTC8CharsetBase('UTF-8');
    LATIN1 = ISO_8859_1_getInstance();
    UTF16_LE = new UTF16Charset(true);
    UTF16_BE = new UTF16Charset(false);
  }
}
var replaceNonPrintableCharactersRegex$delegate;
function substr(_this__u8e3s4, start, length) {
  _init_properties_StringExt_kt__eg42u6();
  var low = coerceIn(start >= 0 ? start : _this__u8e3s4.length + start | 0, 0, _this__u8e3s4.length);
  var high = coerceIn(length >= 0 ? low + length | 0 : _this__u8e3s4.length + length | 0, 0, _this__u8e3s4.length);
  var tmp;
  if (high >= low) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = _this__u8e3s4.substring(low, high);
  } else {
    tmp = '';
  }
  return tmp;
}
function substringEquals(_this__u8e3s4, a, aIndex, b, bIndex, count) {
  _init_properties_StringExt_kt__eg42u6();
  if (count === 0)
    return true;
  if (aIndex < 0 || bIndex < 0)
    return false;
  if ((aIndex + count | 0) > a.length)
    return false;
  if ((bIndex + count | 0) > b.length)
    return false;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charSequenceGet(a, aIndex + n | 0) === charSequenceGet(b, bIndex + n | 0)))
        return false;
    }
     while (inductionVariable < count);
  return true;
}
function substr_0(_this__u8e3s4, start) {
  _init_properties_StringExt_kt__eg42u6();
  return substr(_this__u8e3s4, start, _this__u8e3s4.length);
}
function splitInChunks(_this__u8e3s4, size) {
  _init_properties_StringExt_kt__eg42u6();
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.h1();
  var pos = 0;
  while (pos < _this__u8e3s4.length) {
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'kotlin.text.substring' call
    var startIndex = pos;
    // Inline function 'kotlin.math.min' call
    var a = _this__u8e3s4.length;
    var b = pos + size | 0;
    var endIndex = Math.min(a, b);
    // Inline function 'kotlin.js.asDynamic' call
    var element = _this__u8e3s4.substring(startIndex, endIndex);
    out.h(element);
    pos = pos + size | 0;
  }
  return out;
}
function splitKeep(_this__u8e3s4, regex) {
  _init_properties_StringExt_kt__eg42u6();
  var str = _this__u8e3s4;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.h1();
  var lastPos = 0;
  var _iterator__ex2g4s = regex.sh(_this__u8e3s4).a1();
  while (_iterator__ex2g4s.b1()) {
    var part = _iterator__ex2g4s.c1();
    var prange = part.vh();
    if (!(lastPos === prange.f2())) {
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'kotlin.text.substring' call
      var startIndex = lastPos;
      var endIndex = prange.f2();
      // Inline function 'kotlin.js.asDynamic' call
      var element = str.substring(startIndex, endIndex);
      out.h(element);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var element_0 = substring(str, prange);
    out.h(element_0);
    lastPos = prange.e2() + 1 | 0;
  }
  if (!(lastPos === str.length)) {
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'kotlin.text.substring' call
    var startIndex_0 = lastPos;
    // Inline function 'kotlin.js.asDynamic' call
    var element_1 = str.substring(startIndex_0);
    out.h(element_1);
  }
  return out;
}
function withInsertion(_this__u8e3s4, index, insertedText) {
  _init_properties_StringExt_kt__eg42u6();
  var before = substr(_this__u8e3s4, 0, index);
  var after = substr(_this__u8e3s4, index, _this__u8e3s4.length);
  return before + insertedText + after;
}
function withoutRange(_this__u8e3s4, range) {
  _init_properties_StringExt_kt__eg42u6();
  return substr(_this__u8e3s4, 0, range.a2_1) + substr_0(_this__u8e3s4, range.b2_1 + 1 | 0);
}
function withoutIndex(_this__u8e3s4, index) {
  _init_properties_StringExt_kt__eg42u6();
  return substr(_this__u8e3s4, 0, index) + substr_0(_this__u8e3s4, index + 1 | 0);
}
function replaceNonPrintableCharactersRegex$delegate$lambda() {
  _init_properties_StringExt_kt__eg42u6();
  return Regex.oh('[^ -~]');
}
var properties_initialized_StringExt_kt_sd962o;
function _init_properties_StringExt_kt__eg42u6() {
  if (!properties_initialized_StringExt_kt_sd962o) {
    properties_initialized_StringExt_kt_sd962o = true;
    replaceNonPrintableCharactersRegex$delegate = lazy(replaceNonPrintableCharactersRegex$delegate$lambda);
  }
}
function _WChar___init__impl__4vbl4k(codePoint) {
  return codePoint;
}
function _WChar___get_codePoint__impl__c8brwu($this) {
  return $this;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function substr_1(_this__u8e3s4, start, length) {
  length = length === VOID ? _this__u8e3s4.a() : length;
  var low = coerceIn(start >= 0 ? start : _this__u8e3s4.a() + start | 0, 0, _this__u8e3s4.a());
  var high = coerceIn(length >= 0 ? low + length | 0 : _this__u8e3s4.a() + length | 0, 0, _this__u8e3s4.a());
  return high < low ? Companion_getInstance_0().mw('') : _this__u8e3s4.xg(low, high);
}
function extract(_this__u8e3s4, offset, count) {
  return (_this__u8e3s4 >>> offset | 0) & mask(count);
}
function insert(_this__u8e3s4, value, offset, count) {
  var mask_0 = mask(count) << offset;
  var ovalue = value << offset & mask_0;
  return _this__u8e3s4 & ~mask_0 | ovalue;
}
function getS16(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getS16LE(_this__u8e3s4, offset) : getS16BE(_this__u8e3s4, offset);
}
function mask(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
function getS16LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.io.lang.internal.get16LE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getS16BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.io.lang.internal.get16BE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 1 | 0) << 0 | u8(_this__u8e3s4, offset + 0 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function signExtend(_this__u8e3s4, bits) {
  return _this__u8e3s4 << (32 - bits | 0) >> (32 - bits | 0);
}
function u8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function isWhitespaceFast(_this__u8e3s4) {
  return _this__u8e3s4 === _Char___init__impl__6a9atx(32) || _this__u8e3s4 === _Char___init__impl__6a9atx(9) || _this__u8e3s4 === _Char___init__impl__6a9atx(13) || _this__u8e3s4 === _Char___init__impl__6a9atx(10);
}
function isLetterDigitOrUnderscore(_this__u8e3s4) {
  return isLetterOrDigit(_this__u8e3s4) || _this__u8e3s4 === _Char___init__impl__6a9atx(95) || _this__u8e3s4 === _Char___init__impl__6a9atx(36);
}
function isDigit(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
}
function isLetterOrDigit(_this__u8e3s4) {
  return isLetter(_this__u8e3s4) || isDigit(_this__u8e3s4);
}
function isLetter(_this__u8e3s4) {
  return (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false);
}
function unquote(_this__u8e3s4) {
  var tmp;
  if (isQuoted(_this__u8e3s4)) {
    // Inline function 'kotlin.text.substring' call
    var endIndex = _this__u8e3s4.length - 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = _this__u8e3s4.substring(1, endIndex);
    tmp = unescape(tmp$ret$1);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function isQuoted(_this__u8e3s4) {
  return startsWith(_this__u8e3s4, _Char___init__impl__6a9atx(34)) && endsWith(_this__u8e3s4, _Char___init__impl__6a9atx(34));
}
function unescape(_this__u8e3s4) {
  var out = StringBuilder.tb(_this__u8e3s4.length);
  var n = 0;
  while (n < _this__u8e3s4.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var c = charSequenceGet(_this__u8e3s4, _unary__edvuaz);
    if (c === _Char___init__impl__6a9atx(92)) {
      var _unary__edvuaz_0 = n;
      n = _unary__edvuaz_0 + 1 | 0;
      var c2 = charSequenceGet(_this__u8e3s4, _unary__edvuaz_0);
      if (c2 === _Char___init__impl__6a9atx(92))
        out.pb(_Char___init__impl__6a9atx(92));
      else if (c2 === _Char___init__impl__6a9atx(34))
        out.pb(_Char___init__impl__6a9atx(34));
      else if (c2 === _Char___init__impl__6a9atx(110))
        out.pb(_Char___init__impl__6a9atx(10));
      else if (c2 === _Char___init__impl__6a9atx(114))
        out.pb(_Char___init__impl__6a9atx(13));
      else if (c2 === _Char___init__impl__6a9atx(116))
        out.pb(_Char___init__impl__6a9atx(9));
      else if (c2 === _Char___init__impl__6a9atx(120) || c2 === _Char___init__impl__6a9atx(117)) {
        var N = c2 === _Char___init__impl__6a9atx(117) ? 4 : 2;
        // Inline function 'kotlin.text.substring' call
        var startIndex = n;
        var endIndex = n + N | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var chars = _this__u8e3s4.substring(startIndex, endIndex);
        n = n + N | 0;
        out.pb(numberToChar(toInt(chars, 16)));
      } else {
        out.ob('\\' + toString_0(c2));
      }
    } else
      out.pb(c);
  }
  return out.toString();
}
function substringAfterOrNull(_this__u8e3s4, delimiter) {
  return contains(_this__u8e3s4, delimiter) ? substringAfter(_this__u8e3s4, delimiter) : null;
}
function substringBeforeOrNull(_this__u8e3s4, delimiter) {
  return contains(_this__u8e3s4, delimiter) ? substringBefore(_this__u8e3s4, delimiter) : null;
}
var INDENTS_instance;
function INDENTS_getInstance() {
  if (INDENTS_instance === VOID)
    new INDENTS();
  return INDENTS_instance;
}
function skipWhile(_this__u8e3s4, cond) {
  while (_this__u8e3s4.cw()) {
    var c = _this__u8e3s4.rw();
    if (!cond(new Char(c))) {
      return _this__u8e3s4;
    }
    _this__u8e3s4.sw();
  }
  return _this__u8e3s4;
}
function get_eof(_this__u8e3s4) {
  return !_this__u8e3s4.cw();
}
function skipSpaces(_this__u8e3s4) {
  skipWhile(_this__u8e3s4, skipSpaces$lambda);
  return _this__u8e3s4;
}
function skipExpect(_this__u8e3s4, expected) {
  var readed = _this__u8e3s4.sw();
  if (!(readed === expected)) {
    throw IllegalArgumentException.l("Expected '" + toString_0(expected) + "' but found '" + toString_0(readed) + "' at " + _this__u8e3s4.tw());
  }
}
function readUntilBuilder(_this__u8e3s4, char, out, included) {
  included = included === VOID ? false : included;
  // Inline function 'korlibs.util.readUntilBuilder' call
  $l$loop: while (_this__u8e3s4.cw()) {
    var c = _this__u8e3s4.rw();
    // Inline function 'korlibs.util.readUntilBuilder.<anonymous>' call
    if (c === char) {
      if (included) {
        _this__u8e3s4.sw();
        out.pb(c);
      }
      break $l$loop;
    }
    _this__u8e3s4.sw();
    out.pb(c);
  }
  return out;
}
function matchSingleOrDoubleQuoteString(_this__u8e3s4, out) {
  var tmp12_subject = _this__u8e3s4.rw();
  var tmp;
  if (tmp12_subject === _Char___init__impl__6a9atx(39) || tmp12_subject === _Char___init__impl__6a9atx(34)) {
    var quoteType = _this__u8e3s4.sw();
    out.pb(quoteType);
    tmp = readUntilBuilder(_this__u8e3s4, quoteType, out, true);
  } else {
    tmp = null;
  }
  return tmp;
}
function matchIdentifier(_this__u8e3s4, out) {
  // Inline function 'kotlin.takeIf' call
  // Inline function 'korlibs.util.readWhileBuilder' call
  // Inline function 'korlibs.util.readUntilBuilder' call
  $l$loop: while (_this__u8e3s4.cw()) {
    var c = _this__u8e3s4.rw();
    // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
    // Inline function 'korlibs.util.matchIdentifier.<anonymous>' call
    if (!(isLetterDigitOrUnderscore(c) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(126) || c === _Char___init__impl__6a9atx(58))) {
      if (false) {
        _this__u8e3s4.sw();
        out.pb(c);
      }
      break $l$loop;
    }
    _this__u8e3s4.sw();
    out.pb(c);
  }
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.util.matchIdentifier.<anonymous>' call
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(out) > 0) {
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function tryExpect(_this__u8e3s4, char, consume) {
  consume = consume === VOID ? true : consume;
  var read = _this__u8e3s4.rw();
  var isExpected = read === char;
  if (consume && isExpected) {
    _this__u8e3s4.sw();
  }
  return isExpected;
}
function skipSpaces$lambda(it) {
  return isWhitespaceFast(it.k2_1);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Charset, 'Charset');
initMetadataForClass(UTC8CharsetBase, 'UTC8CharsetBase');
initMetadataForClass(BaseSingleByteCharset, 'BaseSingleByteCharset');
initMetadataForClass(SingleByteCharset, 'SingleByteCharset');
initMetadataForObject(ISO_8859_1, 'ISO_8859_1');
initMetadataForClass(UTF16Charset, 'UTF16Charset');
initMetadataForObject(ASCII, 'ASCII');
initMetadataForObject(Charsets, 'Charsets');
initMetadataForClass(WStringReader, 'WStringReader');
initMetadataForCompanion(Companion_0);
initMetadataForClass(WString, 'WString');
initMetadataForObject(INDENTS, 'INDENTS');
initMetadataForInterface(SimpleStrReader, 'SimpleStrReader');
initMetadataForClass(Impl, 'Impl', VOID, VOID, [SimpleStrReader]);
initMetadataForCompanion(Companion_1);
//endregion
//region block: init
Companion_instance = new Companion();
Charsets_instance = new Charsets();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  _WChar___get_codePoint__impl__c8brwu as _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich,
  ASCII_getInstance as ASCII_getInstancey3nspn0nzsaa,
  Charsets_instance as Charsets_instance2e55bmt8joybi,
  Companion_getInstance_0 as Companion_getInstance6aal8l6ipt6u,
  INDENTS_getInstance as INDENTS_getInstance3i2j33y4c5i8i,
  Companion_instance_1 as Companion_instancem01nsetwb8p0,
  get_UTF16_BE as get_UTF16_BE3rxrt7v8707y4,
  get_UTF8 as get_UTF82geyfhi1l22xl,
  WStringReader as WStringReader2bukzqxb5clbi,
  WString as WStringambx64bqrrmq,
  splitInChunks as splitInChunks2h1zfocl4rvqy,
  splitKeep as splitKeep2hxk3xif9u3vx,
  substringEquals as substringEqualse7vi4930fev5,
  substr as substr1q77u5lo4evr6,
  substr_0 as substr2jonrcqd8qwvx,
  toString_1 as toString2x583ovdqfjci,
  withInsertion as withInsertion32qy0wb7w2f46,
  withoutIndex as withoutIndex1982826lx7knb,
  withoutRange as withoutRangetvtevgxw4fe7,
  isWhitespaceFast as isWhitespaceFast2iszcfvpi3biz,
  substringAfterOrNull as substringAfterOrNull6pqoc8ojvu1x,
  substringBeforeOrNull as substringBeforeOrNullyyd9hl5du3pj,
  unquote as unquote1kjyk5vajgaow,
  toStringContext as toStringContext20qw1vqodfj0k,
  SimpleStrReader as SimpleStrReader35udnj8g5ojo6,
  get_eof as get_eofrk1bzx8ckgtd,
  matchIdentifier as matchIdentifier3b7zgfy94bf8r,
  matchSingleOrDoubleQuoteString as matchSingleOrDoubleQuoteString398sq4vhn9fz,
  readUntilBuilder as readUntilBuilderazvgts3bogti,
  skipExpect as skipExpect1tagjz9aj6y5q,
  skipSpaces as skipSpaces25iogcdi8m3q2,
  tryExpect as tryExpect2a3h5rf36r8u1,
};
//endregion
